import { useEffect } from 'react';
import { IS_PROD } from '../constants';
import { supportsWebp } from '../utils/webpSupport';

const toPngUrl = (url: string) => url.replace(/\.webp$/, '.png');

const logMissingPngFallback = (webpUrl: string) => {
  const pngUrl = toPngUrl(webpUrl);
  const check = new Image();
  check.onerror = () =>
    console.error(
      `usePreloadImages: no PNG fallback for "${webpUrl}" — expected "${pngUrl}" to exist next to it`,
    );
  check.src = pngUrl;
};

export const usePreloadImages = (imageUrls: string[] | undefined) => {
  useEffect(() => {
    if (!imageUrls?.length) return;

    const preload = (url: string) => {
      new Image().src = url;
    };

    const webpUrls = imageUrls.filter((url) => url.endsWith('.webp'));

    if (!IS_PROD) {
      webpUrls.forEach(logMissingPngFallback);
    }

    if (!webpUrls.length) {
      imageUrls.forEach(preload);
      return;
    }

    supportsWebp().then((isSupported) => {
      imageUrls.forEach((url) => preload(isSupported ? url : toPngUrl(url)));
    });
  }, [imageUrls]);
};
